var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#e4e6ea}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "post_add-24px",
    transform: "translate(.03 .03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    transform: "translate(-.03 -.03)",
    style: {
      fill: "none"
    },
    d: "M0 0h90v90H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    transform: "translate(11.246 7.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11472",
    "data-name": "Path 11472",
    className: "cls-2",
    d: "M55.483 58.307H10.5V12.5h26.239V5H10.5A7.52 7.52 0 0 0 3 12.5v44.983a7.52 7.52 0 0 0 7.5 7.5h44.983a7.52 7.52 0 0 0 7.5-7.5V31.241h-7.5z",
    transform: "translate(-3 6.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11473",
    "data-name": "Path 11473",
    className: "cls-2",
    d: "M32.744 2h-7.5v11.246H14c.037.037 0 7.5 0 7.5h11.246v11.207c.037.037 7.5 0 7.5 0V20.744H43.99v-7.5H32.744z",
    transform: "translate(27.236 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    className: "cls-2",
    transform: "translate(14.724 26.473)",
    d: "M0 0h30v7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11474",
    "data-name": "Path 11474",
    className: "cls-2",
    d: "M7 12v7.5h29.99V12H7z",
    transform: "translate(7.995 25.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    className: "cls-2",
    transform: "translate(14.724 48.473)",
    d: "M0 0h30v8H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.820fdda15e43695080afe04382cf4287.svg";
export { ForwardRef as ReactComponent };